import { useEffect, useState } from 'react'
import { Suit } from './ui'
import { Joker } from './Joker'

/**
 * The card that opens the console: four suits deal out around a card back, the
 * card flips to the Joker himself, his bells ring once, and the whole thing
 * lifts away.
 *
 * Three rules it follows, because a splash screen that breaks any of them stops
 * being a flourish and becomes an obstacle:
 *
 *   1. It never blocks the app. The console mounts and fetches underneath; this
 *      is an overlay that leaves, not a gate that opens.
 *   2. It is skippable. Click, tap or any key dismisses it immediately.
 *   3. `prefers-reduced-motion` skips it outright rather than playing it slower.
 *      A flipping card is exactly the kind of motion that setting is about.
 */
const HOLD_MS = 1900

export function Splash() {
  const [state, setState] = useState<'playing' | 'leaving' | 'gone'>(() =>
    typeof window !== 'undefined' &&
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
      ? 'gone'
      : 'playing',
  )

  useEffect(() => {
    if (state !== 'playing') return
    const dismiss = () => setState('leaving')
    const timer = window.setTimeout(dismiss, HOLD_MS)
    window.addEventListener('keydown', dismiss)
    return () => {
      window.clearTimeout(timer)
      window.removeEventListener('keydown', dismiss)
    }
  }, [state])

  useEffect(() => {
    if (state !== 'leaving') return
    const timer = window.setTimeout(() => setState('gone'), 520)
    return () => window.clearTimeout(timer)
  }, [state])

  if (state === 'gone') return null

  return (
    <div
      className={`splash${state === 'leaving' ? ' leaving' : ''}`}
      onClick={() => setState('leaving')}
      /* Decorative and self-dismissing: announcing it would only interrupt. */
      aria-hidden="true"
    >
      <div className="splash-stage">
        <Suit name="spade" className="fly f1" />
        <Suit name="heart" className="fly f2" />
        <Suit name="diamond" className="fly f3" />
        <Suit name="club" className="fly f4" />

        <div className="splash-card">
          <div className="face back" />
          <div className="face front">
            <span className="corner tl">J</span>
            <Joker />
            <span className="card-name">JOKER</span>
            <span className="corner br">J</span>
          </div>
        </div>
      </div>
      <p className="splash-word">Joker</p>
    </div>
  )
}
